import { render, staticRenderFns } from "./MbAudioInGame.vue?vue&type=template&id=326384f8&scoped=true&"
import script from "./MbAudioInGame.vue?vue&type=script&lang=js&"
export * from "./MbAudioInGame.vue?vue&type=script&lang=js&"
import style0 from "./MbAudioInGame.vue?vue&type=style&index=0&id=326384f8&lang=sass&scoped=true&"
import style1 from "./MbAudioInGame.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326384f8",
  null
  
)

export default component.exports